import { TFunction } from 'react-i18next'
import * as yup from 'yup'
import { useYupFields } from 'hooks/forms/useYupFields'

export type ContactInstrumentFormData = {
  description: string
  currencyAndNetwork: string
  walletAddress: string
  tag?: string
  otp: string
  selfHosted?: boolean
}

export type ContactInstrumentFormKeys = keyof ContactInstrumentFormData

export const useContactInstrumentSchema = (t: TFunction<'translation', undefined>) => {
  const { getRequiredYupField, getYupField } = useYupFields()

  return yup.object({
    description: getRequiredYupField({
      label: t('formFields.addressDescription'),
    }),
    currencyAndNetwork: getRequiredYupField({
      label: t('formFields.currencyAndNetwork'),
      requiredErrorMessage: t('formFields.required.currencyAndNetwork'),
    }),
    walletAddress: getRequiredYupField({
      label: t('formFields.walletAddress'),
    }).test('no-trailing-spaces', '', (_value, ctx) => {
      const rawValue = (ctx as yup.TestContext & { originalValue: string }).originalValue
      if (rawValue && rawValue !== rawValue.trim()) {
        return ctx.createError({
          message: t('formFields.errors.noTrailingSpaces', {
            field: t('formFields.walletAddress'),
            interpolation: { escapeValue: false },
          }),
        })
      }
      return true
    }),
    tag: getYupField({
      label: `${t('formFields.destinationTag')} (${t('optional')})`,
    }),
    otp: getRequiredYupField({
      label: t('formFields.otp'),
      requiredErrorMessage: t('formFields.required.otp'),
    }),
    selfHosted: getYupField({
      label: t('formFields.isSelfHosted'),
    }),
  })
}
